import React from "react";
import { Link } from "react-router-dom";

const InnerContactInfo = () => {
  const info_items = [
    {
      src: "/img/icon/loction_icon03.png",
      title: "Address",
      desc: (
        <>
          <p>Level 3, 85 Macquarie Street, Hobart, TAS</p>
        </>
      ),
    },
    {
      src: "/img/icon/mail_icon03.png",
      title: "Email",
      desc: (
        <>
          <Link to="mailto:info@innovatixhub.com.au">info@innovatixhub.com.au</Link>
        </>
      ),
    },
    {
      src: "/img/icon/phone_icon03.png",
      title: "Call Us",
      desc: (
        <>
        <span className="" style={{display: "flex"}}>
          <a href="tel:+61485972839">+61485972839</a>
          <>/</>
          <a href="tel:+61480008440">+61480008440</a>
          </span>
        </>
      ),
    },
  ];

  return (
    <ul className="list-wrap">
      {info_items.map((x, index) => (
        <li key={index}>
          <div className="contact-info-item">
            <div className="icon">
              <img src={x.src} alt="" />
            </div>
            <div className="content">
              <h6 className="title">{x.title}</h6>
              {x.desc}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default InnerContactInfo;
